import React from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { editRoleCancel, fetchRole } from '../actions';

const CancelRoleAction = ({
  role,
  category,
  code,
  isDirty,
  refresh,
  cancelUpdate,
}) => {
  const intl = useIntl();
  const restoreRole = (updates) => {
    if (updates) {
      refresh(category, code);
    } else {
      cancelUpdate(category, code);
    }
  };

  const handleOnClick = () => {
    const updates = !isEqual(role.name, role.copy.name)
        || !isEqual(role.description, role.copy.description)
        || !isEqual(role.permissions, role.copy.permissions);
    const cancel = !isDirty
    || !updates
    || window.confirm(intl.formatMessage({ id: 'role.edit.cancel.warning' }));

    if (cancel) {
      restoreRole(updates);
    }
  };

  return (
    <RibbonMenu
      name="cancel"
      icon="cancel"
      message="actions.cancel"
      onClick={handleOnClick}
      className="aridhia-cancel-role-action"
    />
  );
};

const mapStateToProps = ({
  roles: { roles },
}, { category, code }) => {
  const role = findResult(roles, category, code);
  return {
    role,
    isDirty: role ? role.isDirty : false,
  };
};

const mapDispatchToProps = {
  refresh: fetchRole,
  cancelUpdate: editRoleCancel,
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelRoleAction);
